import cn from 'classnames';
import React from 'react';

import style from './style.module.scss';

export const Content = (props: React.TdHTMLAttributes<any>): React.ReactElement => {
  const { className, ...restProps } = props;
  return <td className={cn(className, style.content)} {...restProps} />;
};
